<template>
  <span :class="nameClass">
    <!-- {{ getCurrencySymbol(currencySymbol, currency.symbol, currency.rates) }} -->
    {{ getPrice(price, currencyCode, currency.rates) }}
    {{ getCurrencyCode(currencyCode, currency.code, currency.rates) }}
  </span>
</template>

<script>
export default {
  props: {
    price: {
      type: Number,
      default: 0,
      description: "Price"
    },
    currency: {
      type: Object,
      default: () => null,
      description: "Currency"
    },
    currencyCode: {
      type: String,
      default: "EUR",
      description: "Currency code"
    },
    currencySymbol: {
      type: String,
      default: "€",
      description: "Currency Symbol"
    },
    nameClass: {
      type: String,
      default: "",
      description: "Class"
    }
  },
  data() {
    return {};
  },
  watch: {},
  async created() {},
  methods: {
    getPrice(price, currencyCode, rates) {
      if (rates && currencyCode) {
        var total = parseFloat(price);
        let rate = parseFloat(rates[currencyCode].toFixed(5));
        let gross = parseFloat(total.toFixed(2)) / rate;
        return gross.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      } else {
        return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
      }
    },
    getCurrencyCode(localCurrencyCode, globalCurrencyCode, rates = []) {
      if (rates) {
        return globalCurrencyCode;
      } else {
        return localCurrencyCode;
      }
    },
    getCurrencySymbol(localCurrencySymbol, globalCurrencySymbol, rates = []) {
      if (rates) {
        return globalCurrencySymbol;
      } else {
        return localCurrencySymbol;
      }
    }
  },
  computed: {},
  components: {}
};
</script>
